<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="700px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="error"
        v-on="on"
        @click="loadData"
      >
        Close Payroll Period
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Payroll Period"
      text="Close Payroll Period Confirmation"
      class="mb-0"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-card-title>
            <span class="headline">Are you sure?</span>
          </v-card-title>
          <v-card-text>
            Make sure your payroll is done. Once you confirm to close the period, it cannot be revert and compute again. Do you wish to proceed?
            <v-checkbox
              v-if="eLetterConfirmation"
              v-model="requestELetter"
            >
              <template v-slot:label>
                <div>
                  e-Letter
                </div>
              </template>
            </v-checkbox>
            <v-text v-if="eLetterConfirmation && requestELetter">
              This date will apply to the remaining bonus letter that has not been released (if any).
            </v-text>
            <v-menu
              v-if="eLetterConfirmation && requestELetter"
              v-model="letterDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="letterDateDisplay"
                  v-validate="'required'"
                  outlined
                  readonly
                  label="Letter Date"
                  :error-messages="errors.collect('letterDateDisplay')"
                  data-vv-name="letterDateDisplay"    
                  data-vv-as="letter date"
                  :class="{
                    'required':!letterDateDisplay
                  }"
                  class="label-position" 
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="letterDate"
                @input="letterDateMenu = false"
              />
            </v-menu>
          </v-card-text>     
        </v-container>
      </form>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="closeDialog"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"  
          class="white--text px-10"           
          @click="closePayrollPeriod"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollPeriodData: {
        type: Object,
        default: null,
      },
    },    
    data () {
      return {
        loading: false,
        progressing: false,
        dialog: null,
        requestELetter: true,
        payrollTransactionDetails: [],
        letterDate: null,
        letterDateMenu: false,
        eLetterConfirmation: false,
        latestPayrollCycleEmployees: null,
      }
    },
    computed: {
      letterDateDisplay () {
        return this.letterDate ? this.$moment(this.letterDate, 'YYYY-MM-DD').format('DD MMM YYYY') : ''
      },
    },
    methods: {
      loadData () {
        this.loading = true
        this.payrollTransactionDetails = []

        this.$api.payrollPeriods().show(this.payrollPeriodData.payrollPeriod + '-01', '?close=true')
          .then(res => {
            res.data.payroll_cycle_transactions.map(data => {
              this.latestPayrollCycleEmployees = data.payroll_cycle_employees

              this.eLetterConfirmation = this.latestPayrollCycleEmployees.some(detail => detail.payroll_transaction_details.length > 0)
            })
          }).catch((e) => {
            if (e.response.status === 404) {
              console.clear()
            }
          }).then(() => {
            this.loading = false
          })
      }, 
      closePayrollPeriod () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            
            this.progressing = true
            this.$api.payrollPeriods().close(this.prepareFormData())
              .then(res => {
                this.$emit('closed')
                this.closeDialog()
              })
              .catch(() => {
                this.$snack({ color: 'error', message: 'Error! Unable to close payroll period.' })
              })
              .then(() => {
                this.progressing = false
              }) 
          })
      },      
      closeDialog () {
        this.dialog = false
      },
      prepareFormData () {
        if (this.eLetterConfirmation) {
          return {
            date: this.payrollPeriodData.payrollPeriod + '-01',
            is_e_letter_sent: this.requestELetter === true ? 1 : 0,
            letter_date: this.requestELetter === true ? this.letterDate : null,
          }
        } else {
          return {
            date: this.payrollPeriodData.payrollPeriod + '-01',
          }
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
